import AppointmentsTable from './AppointmentsTable'
export default AppointmentsTable